const Icons = {
  "chevron-right": {
    viewBox: "0 0 24 24",
    paths: ["M9 18L15 12 9 6"],
  },
};

export default Icons;
